import {createFileRoute} from '@tanstack/react-router';

import {AdvanceRequestDetailPage} from '@/modules/advance-requests/pages/AdvanceRequestDetailPage';

// The page has no tabs: the whole record reads in one column, and the final
// approver's line decisions replace the read-only lines in place. An old
// `?tab=` link is ignored and lands on the same page.
const RouteComponent = () => {
  const {advanceId} = Route.useParams();
  return <AdvanceRequestDetailPage advanceId={advanceId} />;
};

export const Route = createFileRoute('/_authenticated/advances/$advanceId')({
  component: RouteComponent,
});
